export default "__VITE_ASSET__f5efa6f3__"